import { Button } from "components/DesignSystem/Button/Button";
import { FieldArray, FormikValues, useFormikContext } from "formik";
import { SmallCrossPlusIcon } from "components/icons/SmallCrossPlusIcon";
import { emptyOtherRole, OtherRoleEntry } from "./addPersonModal.utils";
import { OtherRoleCard } from "./OtherRoleCard";

export const OtherRolesSection = ({ isEditMode }: { isEditMode: boolean }) => {
  const { values } = useFormikContext<FormikValues>();
  const otherRoles = values.otherRoles as OtherRoleEntry[];

  return (
    <FieldArray name="otherRoles">
      {({ push, remove }) => (
        <>
          {otherRoles.map((entry, index) => (
            <OtherRoleCard
              key={entry.joinId ?? entry.clientId}
              index={index}
              isLocked={isEditMode && Boolean(entry.joinId)}
              onRemove={() => remove(index)}
            />
          ))}
          <Button
            type="button"
            customType="secondary"
            onClick={() => push(emptyOtherRole())}
            className="!t-h-auto t-self-start !t-rounded-md !t-border-neutral-10 !t-bg-surface !t-px-3 !t-py-2 !t-text-[12px] !t-leading-[16px] !t-font-medium !t-text-text-60 !t-shadow-xs"
          >
            <span className="t-inline-flex t-items-center t-gap-1">
              <SmallCrossPlusIcon />
              Add another role
            </span>
          </Button>
        </>
      )}
    </FieldArray>
  );
};
